import React from 'react';
import { Box, Container } from '@material-ui/core';
import { ReactNode } from 'react';

import { useStyles } from 'features/app/components/AppContent/styles';

interface AppContentProps {
  children: NonNullable<ReactNode>;
}

export const AppContent: React.FC<AppContentProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <Box flex={1} display="flex" flexDirection="column" className={classes.contentWrapper}>
      <Container className={classes.contentContainer}>{children}</Container>
    </Box>
  );
};
